import React from 'react';
import PropTypes from 'prop-types'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Image from '../../image'
import {
    BoxImageWrap, 
    BoxImageInner, 
    BoxImageSrcWrap,
    BoxImageContent,
    Heading,
    Text} from './box-image.style'

const BoxImage = ({imageSrc, title, desc, ...boxStyles}) => {
    const {boxStyle} = boxStyles;
    let boxImage = getImage(imageSrc);

    return (
        <BoxImageWrap {...boxStyle}>
            <BoxImageInner>
                {imageSrc && (
                    <BoxImageSrcWrap>
                        { <GatsbyImage image={boxImage} alt={title} />}
                    </BoxImageSrcWrap>          
                )}
                <BoxImageContent>
                    {title && <Heading>{title}</Heading>}
                    {desc && <Text>{desc}</Text>}
                </BoxImageContent>
            </BoxImageInner>
        </BoxImageWrap>
    )
}

BoxImage.propTypes = {
    imageSrc: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    title: PropTypes.string,
    desc: PropTypes.string
}

export default BoxImage;